
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search/[term]",
      function () {
        return require("private-next-pages/search/[term].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search/[term]"])
      });
    }
  